import { useEffect, useState } from "react";
import {
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  TextField
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Add, ExpandMore, Edit as EditIcon } from "@mui/icons-material";
import { t } from "i18next";
import api from "../../../../../../helpers/api/Api";
import AppConfig from "../../../../../../helpers/constants/AppConfig";
import ApiUrls from "../../../../../../helpers/urls/ApiUrls";
import { showStatus } from "../../../../../../helpers/api/errors/ShowStatus";
import { appendFormData } from "../../../../../../helpers/functions/form-append";
import MDTypography from "../../../../../../components/MDs/MDTypography";
import MDBox from "../../../../../../components/MDs/MDBox";

function AddIPGroup({ editIP, getList }) {
  const [formData, setFormData] = useState({
    name: "",
    cidr: ""
  });
  const {
    name,
    cidr,
  } = formData;
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [accordion, setAccordion] = useState(false);

  useEffect(() => {
    if (editIP) {
      setFormData(editIP);
      setIsEdit(true);
      setAccordion(true);
    } else {
      setIsEdit(false);
    }
  }, [editIP]);

  const handleChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: null
    });
  };

  const checkInputs = () => {
    let temp_errors = {};

    if (cidr === "") {
      temp_errors.cidr = t("message.required", { item: t("report.ip_group_address") });
    }
    if (name === "") {
      temp_errors.name = t("message.required", { item: t("user.name") });
    }

    setErrors(temp_errors);

    if (Object.keys(temp_errors).length === 0) {
      addItem();
    }
  }

  const addItem = () => {
    setLoading(true);
    const snackArgs = {
      item: "",
      op: isEdit ? t("global.edit") : t("global.add")
    };
    const fd = appendFormData(formData);

    api.post(isEdit ? ApiUrls.ip_group.edit : ApiUrls.ip_group.add, fd)
      .then((response) => {
        setLoading(false);
        showStatus(response.data.status, snackArgs);
        if (response.data.status === "success") {
          getList();
        }
      })
      .catch((error) => {
        setLoading(false);
        showStatus("error", snackArgs);
      });
  }

  const onAccordionChange = () => {
    setAccordion(!accordion);
  }

  return (
    <Grid item xs={12}>
      <Accordion expanded={accordion} onChange={onAccordionChange}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <MDTypography variant="h6" color="white">
            {isEdit ? t("global.edit") : t("global.add")}
          </MDTypography>
        </AccordionSummary>

        <AccordionDetails>
          <MDBox pb={3} pt={2} px={5} justifyContent="center">
            <Grid container>
              <Grid container>
                <Grid item md={4}>
                  <TextField id="name" label={t("user.name")} variant="outlined" fullWidth
                             value={name} error={errors?.name} helperText={errors?.name}
                             onChange={(e) => handleChange("name", e.target.value)}
                  />
                </Grid>
              </Grid>

              <Grid container mt={2}>
                <Grid item md={12}>
                  <TextField id="group" label={t("report.ip_group_address")} variant="outlined" fullWidth
                             multiline minRows={2} className="ltr-textfield"
                             value={cidr} error={errors?.cidr} helperText={errors?.cidr ? errors?.cidr : t("report.ip_group_helper_text")}
                             onChange={(e) => handleChange("cidr", e.target.value)}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} justifyContent="center" mt={3}>
                <Grid item md={3}>
                  <LoadingButton
                    color={AppConfig.color}
                    loading={loading}
                    startIcon={isEdit ? <EditIcon /> : <Add />}
                    variant="outlined"
                    fullWidth
                    onClick={checkInputs}
                  >
                    {t(isEdit ? "button.edit" : "button.add", { item: t("report.ip_group") })}
                  </LoadingButton>
                </Grid>
              </Grid>
            </Grid>
          </MDBox>
        </AccordionDetails>
      </Accordion>
    </Grid>
  )
}

export default AddIPGroup;
